import { authAxios } from "./../../config/axios";

class Withdraws {
  get = (params = []) => {
    return authAxios.get("/plan/withdraws/view", {
      params,
    });
  };

  download = (params = []) => {
    return authAxios.get("administration/withdraws", {
      params,
    });
  };

  total = (data) => {
    return authAxios.post("/plan/withdraws/total", data);
  };

  payments = (data) => {
    return authAxios.post("/plan/withdraws/payments", data);
  };

  saveTransactions = (data) => {
    return authAxios.post("/plan/withdraws/paid", data);
  };

  types = () => {
    return authAxios.get("/plan/withdraws/types");
  };

  cancel = (id) => {
    return authAxios.put(`/plan/withdraws/${id}/Cancelado`);
  };

  complete = (id) => {
    return authAxios.put(`/plan/withdraws/${id}/Completado`);
  };

  withdrawals = () => {
    return authAxios.get("/plan/withdraw-rate");
  };

  createWithdrawal = (name, rate) => {
    let formData = new FormData();

    formData.append('name', name)
    formData.append('rate', rate)

    return authAxios.post("/plan/withdraw-rate", formData);
  };

  editWithdrawal = (id, rate) => {
    return authAxios.put(`/plan/withdraw-rate/${id}`, rate);
  };
}

export default new Withdraws();
